var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRrRefreshRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#C8C9D0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11752_11766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 9.33352C16.8845 9.33642 17.7595 9.51468 18.5745 9.85798C19.3895 10.2013 20.1283 10.7028 20.7482 11.3335H18.6668C18.49 11.3335 18.3205 11.4038 18.1954 11.5288C18.0704 11.6538 18.0002 11.8234 18.0002 12.0002C18.0002 12.177 18.0704 12.3466 18.1954 12.4716C18.3205 12.5966 18.49 12.6669 18.6668 12.6669H21.4288C21.7571 12.6667 22.0719 12.5362 22.304 12.3041C22.5362 12.0719 22.6667 11.7571 22.6668 11.4289V8.66685C22.6668 8.49004 22.5966 8.32047 22.4716 8.19545C22.3466 8.07042 22.177 8.00018 22.0002 8.00018C21.8234 8.00018 21.6538 8.07042 21.5288 8.19545C21.4037 8.32047 21.3335 8.49004 21.3335 8.66685V10.0522C20.2316 9.05982 18.8752 8.39379 17.4162 8.12868C15.9572 7.86358 14.4533 8.00986 13.0727 8.55115C11.6921 9.09244 10.4895 10.0074 9.59952 11.1935C8.70951 12.3796 8.16727 13.79 8.03351 15.2669C8.0249 15.3597 8.03572 15.4533 8.06528 15.5417C8.09485 15.6302 8.14251 15.7115 8.20523 15.7804C8.26794 15.8494 8.34435 15.9046 8.42956 15.9424C8.51478 15.9803 8.60694 15.9999 8.70018 16.0002C8.86323 16.0023 9.0212 15.9434 9.14315 15.8351C9.2651 15.7269 9.34225 15.577 9.35951 15.4149C9.50792 13.7554 10.2715 12.2113 11.5002 11.0861C12.729 9.96083 14.3341 9.33571 16.0002 9.33352Z",
    fill: "#5F606D"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.3007 16.0001C23.1376 15.998 22.9797 16.0568 22.8577 16.1651C22.7358 16.2734 22.6586 16.4232 22.6414 16.5854C22.5312 17.8542 22.0593 19.0648 21.2818 20.0735C20.5043 21.0823 19.4538 21.8468 18.2548 22.2764C17.0559 22.7061 15.7588 22.7828 14.5176 22.4975C13.2764 22.2122 12.143 21.5768 11.252 20.6667H13.3334C13.5102 20.6667 13.6798 20.5965 13.8048 20.4715C13.9298 20.3464 14 20.1769 14 20.0001C14 19.8233 13.9298 19.6537 13.8048 19.5287C13.6798 19.4036 13.5102 19.3334 13.3334 19.3334H10.5714C10.4088 19.3333 10.2477 19.3653 10.0975 19.4275C9.94727 19.4896 9.81076 19.5808 9.69578 19.6958C9.5808 19.8108 9.48962 19.9473 9.42743 20.0975C9.36525 20.2478 9.33329 20.4088 9.33337 20.5714V23.3334C9.33337 23.5102 9.40361 23.6798 9.52864 23.8048C9.65366 23.9298 9.82323 24.0001 10 24.0001C10.1769 24.0001 10.3464 23.9298 10.4714 23.8048C10.5965 23.6798 10.6667 23.5102 10.6667 23.3334V21.9481C11.7686 22.9404 13.125 23.6065 14.584 23.8716C16.043 24.1367 17.547 23.9904 18.9275 23.4491C20.3081 22.9078 21.5107 21.9929 22.4007 20.8068C23.2907 19.6207 23.8329 18.2102 23.9667 16.7334C23.9753 16.6406 23.9645 16.5469 23.9349 16.4585C23.9054 16.3701 23.8577 16.2888 23.795 16.2198C23.7323 16.1508 23.6559 16.0956 23.5707 16.0578C23.4854 16.02 23.3933 16.0003 23.3 16.0001H23.3007Z",
    fill: "#5F606D"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1.2s",
    repeatCount: "indefinite"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11752_11766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrRefreshRotate);
export default __webpack_public_path__ + "static/media/fi-rr-refresh-rotate.575a652f6651e11ff287598d47950fe8.svg";
export { ForwardRef as ReactComponent };